export function formatPlantedAtLabel(value) {
  const raw = String(value || '');
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return raw || '—';
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatPlantingAcres(acres) {
  const value = Number(acres);
  if (!Number.isFinite(value)) return '';
  return `${value.toFixed(1)} ac`;
}

export function formatPlantingWeatherLine(weather) {
  if (!weather || typeof weather !== 'object') return '';
  const bits = [];
  const temp = Number(weather.temperature);
  if (Number.isFinite(temp)) bits.push(String(Math.round(temp)));
  const main = String(weather.main || '').trim();
  if (main) bits.push(main);
  return bits.join(' ');
}

export function isPlantingPlanMissing(event, savedGroups = [], { plansReady = true } = {}) {
  if (!event) return false;
  if (event.area_group == null || event.area_group === '') return true;
  if (!plansReady) return false;
  const planId = event.area_group;
  return !(Array.isArray(savedGroups) ? savedGroups : []).some((group) => group?.id === planId);
}

export function findLivePlanForEvent(event, savedGroups = []) {
  if (event?.area_group == null) return null;
  return (Array.isArray(savedGroups) ? savedGroups : []).find((group) => group?.id === event.area_group) || null;
}

export function buildPlantingLogRow(event, savedGroups = [], { plansReady = true } = {}) {
  const missing = isPlantingPlanMissing(event, savedGroups, { plansReady });
  const meta = [
    formatPlantedAtLabel(event?.planted_at),
    event?.blend_name,
    formatPlantingAcres(event?.acres),
    formatPlantingWeatherLine(event?.weather_data),
  ].filter(Boolean).join(' · ');
  return {
    id: event?.id,
    title: (event?.plan_name || '').trim() || 'Untitled plan',
    meta,
    notes: String(event?.notes || '').trim(),
    missing,
    event,
  };
}

export function buildPlantingLogDeleteCopy(event) {
  const name = (event?.plan_name || '').trim() || 'this plan';
  const dateLabel = formatPlantedAtLabel(event?.planted_at);
  const when = dateLabel && dateLabel !== '—' ? ` from ${dateLabel}` : '';
  return {
    title: 'Remove this planting from the log?',
    body: `This only removes the dated record${when} for ${name}. The plan stays in My Plans, and you can mark it planted again anytime. This can’t be undone.`,
  };
}
